import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shoes-detail',
  templateUrl: './shoes-detail.component.html',
  styleUrls: ['./shoes-detail.component.scss']
})
export class ShoesDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
